import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import SessionForm from './SessionForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { ConfirmationButton } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

class SessionDialog extends Component {
    constructor(props) {
        super(props);
    }

    dialogConfig() {
        const { t, onCancel, session } = this.props;

        return {
            header: session && session.id ? t('Workshop_Edit_Session') : t('Workshop_Add_Session'),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm, session, workshopSessionTypes } = this.props;
        return <SessionForm onSubmit={onConfirm} initialValues={session} workshopSessionTypes={workshopSessionTypes}/>;
    }

    renderFooter() {
        const { onCancel, onDelete, session, isReadonly, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = !isReadonly && <RemoteSubmitButton key='save' style='primary' formName='session' label={t('Common_Save')} />;
        const deleteBtn = !isReadonly && session && session.id && <ConfirmationButton style={{ marginLeft: '5px', marginRight: '5px' }}
            onConfirmation={() => onDelete(session.id)}
            confirmationTitle={t('Workshop_DeleteConfirmationTitle')}
            confirmationMessage={t('Workshop_DeleteConfirmationMessage', { type: session.typeName, date: ui.formatDate(session.date) })}
            displayType={'inline'}
            label={t('Common_Delete')}
        />
        return [closeBtn, deleteBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

SessionDialog.propTypes = {
    show: PropTypes.bool,
    to: PropTypes.array,
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(SessionDialog);